import GestureManager from './GestureManager';

export default GestureManager;
